function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * dd-draggable.ts 10.3.1
 * Copyright (c) 2021-2022 Alain Dumesny - see GridStack root license
 */
import { DDManager } from './dd-manager';
import { Utils } from './utils';
import { DDBaseImplement } from './dd-base-impl';
import { isTouch, touchend, touchmove, touchstart, pointerdown } from './dd-touch';
// make sure we are not clicking on known object that handles mouseDown
var skipMouseDown = 'input,textarea,button,select,option,[contenteditable="true"],.ui-resizable-handle';
// let count = 0; // TEST
var DDDraggable = /*#__PURE__*/function (_DDBaseImplement) {
  function DDDraggable(el) {
    var _this;
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, DDDraggable);
    _this = _callSuper(this, DDDraggable);
    _this.el = el;
    _this.option = option;
    /** @internal */
    _this.dragTransform = {
      xScale: 1,
      yScale: 1,
      xOffset: 0,
      yOffset: 0
    };
    // get the element that is actually supposed to be dragged by
    var handleName = option.handle.substring(1);
    var n = el.gridstackNode;
    _this.dragEls = el.classList.contains(handleName) ? [el] : n !== null && n !== void 0 && n.subGrid ? [el.querySelector(option.handle) || el] : Array.from(el.querySelectorAll(option.handle));
    if (_this.dragEls.length === 0) {
      _this.dragEls = [el];
    }
    // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
    _this._mouseDown = _this._mouseDown.bind(_this);
    _this._mouseMove = _this._mouseMove.bind(_this);
    _this._mouseUp = _this._mouseUp.bind(_this);
    _this._keyEvent = _this._keyEvent.bind(_this);
    _this.enable();
    return _this;
  }
  _inherits(DDDraggable, _DDBaseImplement);
  return _createClass(DDDraggable, [{
    key: "on",
    value: function on(event, callback) {
      _superPropGet(DDDraggable, "on", this, 3)([event, callback]);
    }
  }, {
    key: "off",
    value: function off(event) {
      _superPropGet(DDDraggable, "off", this, 3)([event]);
    }
  }, {
    key: "enable",
    value: function enable() {
      var _this2 = this;
      if (this.disabled === false) return;
      _superPropGet(DDDraggable, "enable", this, 3)([]);
      this.dragEls.forEach(function (dragEl) {
        dragEl.addEventListener('mousedown', _this2._mouseDown);
        if (isTouch) {
          dragEl.addEventListener('touchstart', touchstart);
          dragEl.addEventListener('pointerdown', pointerdown);
          // dragEl.style.touchAction = 'none'; // not needed unlike pointerdown doc comment
        }
      });
      this.el.classList.remove('ui-draggable-disabled');
    }
  }, {
    key: "disable",
    value: function disable() {
      var _this3 = this;
      var forDestroy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.disabled === true) return;
      _superPropGet(DDDraggable, "disable", this, 3)([]);
      this.dragEls.forEach(function (dragEl) {
        dragEl.removeEventListener('mousedown', _this3._mouseDown);
        if (isTouch) {
          dragEl.removeEventListener('touchstart', touchstart);
          dragEl.removeEventListener('pointerdown', pointerdown);
        }
      });
      if (!forDestroy) this.el.classList.add('ui-draggable-disabled');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.dragTimeout) window.clearTimeout(this.dragTimeout);
      delete this.dragTimeout;
      if (this.mouseDownEvent) this._mouseUp(this.mouseDownEvent);
      this.disable(true);
      delete this.el;
      delete this.helper;
      delete this.option;
      _superPropGet(DDDraggable, "destroy", this, 3)([]);
    }
  }, {
    key: "updateOption",
    value: function updateOption(opts) {
      var _this4 = this;
      Object.keys(opts).forEach(function (key) {
        return _this4.option[key] = opts[key];
      });
      return this;
    }
    /** @internal call when mouse goes down before a dragstart happens */
  }, {
    key: "_mouseDown",
    value: function _mouseDown(e) {
      // don't let more than one widget handle mouseStart
      if (DDManager.mouseHandled) return;
      if (e.button !== 0) return true; // only left click
      // make sure we are not clicking on known object that handles mouseDown, or ones supplied by the user
      if (!this.dragEls.find(function (el) {
        return el === e.target;
      }) && e.target.closest(skipMouseDown)) return true;
      if (this.option.cancel) {
        if (e.target.closest(this.option.cancel)) return true;
      }
      // REMOVE: why would we get the event if it wasn't for us or child ?
      // make sure we are clicking on a drag handle or child of it...
      // Note: we don't need to check that's handle is an immediate child, as mouseHandled will prevent parents from also handling it (lowest wins)
      // let className = this.option.handle.substring(1);
      // let el = e.target as HTMLElement;
      // while (el && !el.classList.contains(className)) { el = el.parentElement; }
      // if (!el) return;
      this.mouseDownEvent = e;
      delete this.dragging;
      delete DDManager.dragElement;
      delete DDManager.dropElement;
      // document handler so we can continue receiving moves as the item is 'fixed' position, and capture=true so WE get a first crack
      document.addEventListener('mousemove', this._mouseMove, {
        capture: true,
        passive: true
      }); // true=capture, not bubble
      document.addEventListener('mouseup', this._mouseUp, true);
      if (isTouch) {
        e.target.addEventListener('touchmove', touchmove);
        e.target.addEventListener('touchend', touchend);
      }
      e.preventDefault();
      // preventDefault() prevents blur event which occurs just after mousedown event.
      // if an editable content has focus, then blur must be call
      if (document.activeElement) document.activeElement.blur();
      DDManager.mouseHandled = true;
      return true;
    }
    /** @internal method to call actual drag event */
  }, {
    key: "_callDrag",
    value: function _callDrag(e) {
      if (!this.dragging) return;
      var ev = Utils.initEvent(e, {
        target: this.el,
        type: 'drag'
      });
      if (this.option.drag) {
        this.option.drag(ev, this.ui());
      }
      this.triggerEvent('drag', ev);
    }
    /** @internal called when the main page (after successful mousedown) receives a move event to drag the item around the screen */
  }, {
    key: "_mouseMove",
    value: function _mouseMove(e) {
      var _this5 = this;
      // console.log(`${count++} move ${e.x},${e.y}`)
      var s = this.mouseDownEvent;
      this.lastDrag = e;
      if (this.dragging) {
        this._dragFollow(e);
        // delay actual grid handling drag until we pause for a while if set
        if (DDManager.pauseDrag) {
          var pause = Number.isInteger(DDManager.pauseDrag) ? DDManager.pauseDrag : 100;
          if (this.dragTimeout) window.clearTimeout(this.dragTimeout);
          this.dragTimeout = window.setTimeout(function () {
            return _this5._callDrag(e);
          }, pause);
        } else {
          this._callDrag(e);
        }
      } else if (Math.abs(e.x - s.x) + Math.abs(e.y - s.y) > 3) {
        var _this$el$gridstackNod;
        /**
         * don't start unless we've moved at least 3 pixels
         */
        this.dragging = true;
        DDManager.dragElement = this;
        // if we're dragging an actual grid item, set the current drop as the grid (to detect enter/leave)
        var grid = (_this$el$gridstackNod = this.el.gridstackNode) === null || _this$el$gridstackNod === void 0 ? void 0 : _this$el$gridstackNod.grid;
        if (grid) {
          DDManager.dropElement = grid.el.ddElement.ddDroppable;
        } else {
          delete DDManager.dropElement;
        }
        this.helper = this._createHelper(e);
        this._setupHelperContainmentStyle();
        this.dragTransform = Utils.getValuesFromTransformedElement(this.helperContainment);
        this.dragOffset = this._getDragOffset(e, this.el, this.helperContainment);
        this._setupHelperStyle(e);
        var ev = Utils.initEvent(e, {
          target: this.el,
          type: 'dragstart'
        });
        if (this.option.start) {
          this.option.start(ev, this.ui());
        }
        this.triggerEvent('dragstart', ev);
        // now track keyboard events to cancel or rotate
        document.addEventListener('keydown', this._keyEvent);
      }
      // e.preventDefault(); // passive = true. OLD: was needed otherwise we get text sweep text selection as we drag around
      return true;
    }
    /** @internal call when the mouse gets released to drop the item at current location */
  }, {
    key: "_mouseUp",
    value: function _mouseUp(e) {
      document.removeEventListener('mousemove', this._mouseMove, true);
      document.removeEventListener('mouseup', this._mouseUp, true);
      if (isTouch) {
        e.target.removeEventListener('touchmove', touchmove, true);
        e.target.removeEventListener('touchend', touchend, true);
      }
      if (this.dragging) {
        var _this$el$gridstackNod2, _DDManager$dropElemen;
        delete this.dragging;
        (_this$el$gridstackNod2 = this.el.gridstackNode) === null || _this$el$gridstackNod2 === void 0 || delete _this$el$gridstackNod2._origRotate;
        document.removeEventListener('keydown', this._keyEvent);
        // reset the drop target if dragging over ourself (already parented, just moving during stop callback below)
        if (((_DDManager$dropElemen = DDManager.dropElement) === null || _DDManager$dropElemen === void 0 ? void 0 : _DDManager$dropElemen.el) === this.el.parentElement) {
          delete DDManager.dropElement;
        }
        this.helperContainment.style.position = this.parentOriginStylePosition || null;
        if (this.helper === this.el) {
          this._removeHelperStyle();
        } else {
          this.helper.remove();
        }
        var ev = Utils.initEvent(e, {
          target: this.el,
          type: 'dragstop'
        });
        if (this.option.stop) {
          this.option.stop(ev); // NOTE: destroy() will be called when removing item, so expect NULL ptr after!
        }
        this.triggerEvent('dragstop', ev);
        // call the droppable method to receive the item
        if (DDManager.dropElement) {
          DDManager.dropElement.drop(e);
        }
      }
      delete this.helper;
      delete this.mouseDownEvent;
      delete DDManager.dragElement;
      delete DDManager.dropElement;
      delete DDManager.mouseHandled;
      e.preventDefault();
    }
    /** @internal call when keys are being pressed - use Esc to cancel, R to rotate */
  }, {
    key: "_keyEvent",
    value: function _keyEvent(e) {
      var n = this.el.gridstackNode;
      if (!(n !== null && n !== void 0 && n.grid)) return;
      var grid = n.grid;
      if (e.key === 'Escape') {
        if (n._origRotate) {
          n._orig = n._origRotate;
          delete n._origRotate;
        }
        grid.engine.restoreInitial();
        this._mouseUp(this.mouseDownEvent);
      } else if (e.key === 'r' || e.key === 'R') {
        if (!Utils.canBeRotated(n)) return;
        n._origRotate = n._origRotate || _objectSpread({}, n._orig); // store the real orig size in case we Esc after doing rotation
        delete n._moving; // force rotate to happen (move waits for >50% coverage otherwise)
        grid.setAnimation(false) // immediate rotate so _getDragOffset() gets the right dom size below
        .rotate(n.el, {
          top: -this.dragOffset.offsetTop,
          left: -this.dragOffset.offsetLeft
        }).setAnimation();
        n._moving = true;
        this.dragOffset = this._getDragOffset(this.lastDrag, n.el, this.helperContainment);
        this.helper.style.width = this.dragOffset.width + 'px';
        this.helper.style.height = this.dragOffset.height + 'px';
        Utils.swap(n._orig, 'w', 'h');
        delete n._rect;
        this._mouseMove(this.lastDrag);
      }
    }
    /** @internal create a clone copy (or user defined method) of the original drag item if set */
  }, {
    key: "_createHelper",
    value: function _createHelper(event) {
      var _this6 = this;
      var helper = this.el;
      if (typeof this.option.helper === 'function') {
        helper = this.option.helper(event);
      } else if (this.option.helper === 'clone') {
        helper = Utils.cloneNode(this.el);
      }
      if (!document.body.contains(helper)) {
        Utils.appendTo(helper, this.option.appendTo === 'parent' ? this.el.parentElement : this.option.appendTo);
      }
      if (helper === this.el) {
        this.dragElementOriginStyle = DDDraggable.originStyleProp.map(function (prop) {
          return _this6.el.style[prop];
        });
      }
      return helper;
    }
    /** @internal set the fix position of the dragged item */
  }, {
    key: "_setupHelperStyle",
    value: function _setupHelperStyle(e) {
      var _this7 = this;
      this.helper.classList.add('ui-draggable-dragging');
      // TODO: set all at once with style.cssText += ... ? https://stackoverflow.com/questions/3968593
      var style = this.helper.style;
      style.pointerEvents = 'none'; // needed for over items to get enter/leave
      // style.cursor = 'move'; //  TODO: can't set with pointerEvents=none ! (done in CSS as well)
      style.width = this.dragOffset.width + 'px';
      style.height = this.dragOffset.height + 'px';
      style.willChange = 'left, top';
      style.position = 'fixed'; // let us drag between grids by not clipping as parent .grid-stack is position: 'relative'
      this._dragFollow(e); // now position it
      style.transition = 'none'; // show up instantly
      setTimeout(function () {
        if (_this7.helper) {
          style.transition = null; // recover animation
        }
      }, 0);
      return this;
    }
    /** @internal restore back the original style before dragging */
  }, {
    key: "_removeHelperStyle",
    value: function _removeHelperStyle() {
      var _this$helper,
        _this8 = this;
      this.helper.classList.remove('ui-draggable-dragging');
      var node = (_this$helper = this.helper) === null || _this$helper === void 0 ? void 0 : _this$helper.gridstackNode;
      // don't bother restoring styles if we're gonna remove anyway...
      if (!(node !== null && node !== void 0 && node._isAboutToRemove) && this.dragElementOriginStyle) {
        var helper = this.helper;
        // don't animate, otherwise we animate offseted when switching back to 'absolute' from 'fixed'.
        // TODO: this also removes resizing animation which doesn't have this issue, but others.
        // Ideally both would animate ('move' would immediately restore 'absolute' and adjust coordinate to match,
        // then trigger a delay (repaint) to restore to final dest with animate) but then we need to make sure 'resizestop'
        // is called AFTER 'transitionend' event is received (see https://github.com/gridstack/gridstack.js/issues/2033)
        var transition = this.dragElementOriginStyle['transition'] || null;
        helper.style.transition = this.dragElementOriginStyle['transition'] = 'none'; // can't be NULL #1973
        DDDraggable.originStyleProp.forEach(function (prop) {
          return helper.style[prop] = _this8.dragElementOriginStyle[prop] || null;
        });
        setTimeout(function () {
          return helper.style.transition = transition;
        }, 50); // recover animation from saved vars after a pause (0 isn't enough #1973)
      }
      delete this.dragElementOriginStyle;
      return this;
    }
    /** @internal updates the top/left position to follow the mouse */
  }, {
    key: "_dragFollow",
    value: function _dragFollow(e) {
      var containmentRect = {
        left: 0,
        top: 0
      };
      // if (this.helper.style.position === 'absolute') { // we use 'fixed'
      //   const { left, top } = this.helperContainment.getBoundingClientRect();
      //   containmentRect = { left, top };
      // }
      var style = this.helper.style;
      var offset = this.dragOffset;
      style.left = (e.clientX + offset.offsetLeft - containmentRect.left) * this.dragTransform.xScale + 'px';
      style.top = (e.clientY + offset.offsetTop - containmentRect.top) * this.dragTransform.yScale + 'px';
    }
    /** @internal */
  }, {
    key: "_setupHelperContainmentStyle",
    value: function _setupHelperContainmentStyle() {
      this.helperContainment = this.helper.parentElement;
      if (this.helper.style.position !== 'fixed') {
        this.parentOriginStylePosition = this.helperContainment.style.position;
        if (getComputedStyle(this.helperContainment).position.match(/static/)) {
          this.helperContainment.style.position = 'relative';
        }
      }
      return this;
    }
    /** @internal */
  }, {
    key: "_getDragOffset",
    value: function _getDragOffset(event, el, parent) {
      // in case ancestor has transform/perspective css properties that change the viewpoint
      var xformOffsetX = 0;
      var xformOffsetY = 0;
      if (parent) {
        xformOffsetX = this.dragTransform.xOffset;
        xformOffsetY = this.dragTransform.yOffset;
      }
      var targetOffset = el.getBoundingClientRect();
      return {
        left: targetOffset.left,
        top: targetOffset.top,
        offsetLeft: -event.clientX + targetOffset.left - xformOffsetX,
        offsetTop: -event.clientY + targetOffset.top - xformOffsetY,
        width: targetOffset.width * this.dragTransform.xScale,
        height: targetOffset.height * this.dragTransform.yScale
      };
    }
    /** @internal TODO: set to public as called by DDDroppable! */
  }, {
    key: "ui",
    value: function ui() {
      var containmentEl = this.el.parentElement;
      var containmentRect = containmentEl.getBoundingClientRect();
      var offset = this.helper.getBoundingClientRect();
      return {
        position: {
          top: (offset.top - containmentRect.top) * this.dragTransform.yScale,
          left: (offset.left - containmentRect.left) * this.dragTransform.xScale
        }
        /* not used by GridStack for now...
        helper: [this.helper], //The object arr representing the helper that's being dragged.
        offset: { top: offset.top, left: offset.left } // Current offset position of the helper as { top, left } object.
        */
      };
    }
  }]);
}(DDBaseImplement);
/** @internal properties we change during dragging, and restore back */
DDDraggable.originStyleProp = ['transition', 'pointerEvents', 'position', 'left', 'top', 'minWidth', 'willChange'];
export { DDDraggable };